import script from "./form-term.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-term.vue?vue&type=script&setup=true&lang=ts"

import "./form-term.vue?vue&type=style&index=0&id=02aafde3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02aafde3"]])

export default __exports__